import React from 'react';

import Arrows from '../common/input/Arrows.jsx';
import {
  ArtistSlim,
  Artwork as ArtworkCell,
  Gallery as GalleryCell,
  Profile as ProfileCell,
  ShowVertical as ShowCell,
} from '../common/container/Cell.jsx';
import {
  ArtworkGridContainer,
  NoResults,
  Spaced,
  Tab,
  Title,
  forResource,
  Section,
  TitleSpaced,
} from '../common/container/Container.jsx';
import { LinkedImage } from '../common/container/Image.jsx';
import { Component as Landmark } from '../common/container/Landmark.jsx';
import { Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { ListArtworkAdd } from '../common/container/Popup.jsx';
import Prospects from '../common/container/Prospects.jsx';
import { Artists as ArtistsSlider, Artwork as ArtworkSlider, Shows as ShowsSlider } from '../common/container/Slider.jsx';
import { Follow as FollowButton } from '../common/input/Button.jsx';


let _ArtistInst;
class _Artist extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      artwork: {
        dir: 1,
        limit: 20,
        loading: false,
        offset: 0,
        order: 2,
      },
      artworkMarketplace: {
        data: []
      },
      followers: {
        loading: true,
      },
      related: {
        data: [],
        loading: true
      },
      shows: {
        limit: 18,
        loading: false,
        offset: 0,
      },
    };

    this.configureTabs = this.configureTabs.bind(this);
    this.getArtwork = this.getArtwork.bind(this);
    this.getArtworkMarketplace = this.getArtworkMarketplace.bind(this);
    this.getFollowers = this.getFollowers.bind(this);
    this.getRelated = this.getRelated.bind(this);
    this.getShows = this.getShows.bind(this);
    this.handleArtworkLikeChange = this.handleArtworkLikeChange.bind(this);
    this.handleArtworkWaypointEnter = this.handleArtworkWaypointEnter.bind(this);
    this.handleFollowChange = this.handleFollowChange.bind(this);
    this.handleGalleryFollowChange = this.handleGalleryFollowChange.bind(this);
    this.handleListArtworkAddModalClose = this.handleListArtworkAddModalClose.bind(this);
    this.handleParseRelatedArtwork = this.handleParseRelatedArtwork.bind(this);
    this.handleRelatedArtworkLikeChange = this.handleRelatedArtworkLikeChange.bind(this);
    this.handleShowsWaypointEnter = this.handleShowsWaypointEnter.bind(this);
  }

  componentDidMount() {
    _ArtistInst = true;

    const component = this;
    component.props.onRegisterRequestCallback(function (responseData) {
      Artcloud.mkt.artists._isfollowing(responseData);

      if (responseData.Galleries) {
        responseData.Galleries.map(function (d) {
          Artcloud.mkt.galleries._isfollowing(d);
        });
      }

      const id = responseData.ArtistId;

      const user = Artcloud.auth.user;
      if (user) {
          component.setState({
              CanProspect: user.Permissions && user.Permissions.CanProspect,
              Type: user.Type.Value
          });
      }

      if (!responseData.AnyOpted) {
        component.getRelated(id);
        //component.getArtworkMarketplace();
      }
      if (!responseData.IsGhost) {
        component.getArtwork(id);
        component.getFollowers(id);
        component.getShows(id);  
      }
      component.configureTabs(responseData);
    });
  }

  componentWillUnmount() {
    _ArtistInst = undefined;

    if (this.artworkRequest) {
      this.artworkRequest.abort();
      this.artworkRequest = null;
    }
    if (this.followersRequest) {
      this.followersRequest.abort();
      this.followersRequest = null;
    }
    if (this.relatedRequest) {
      this.relatedRequest.abort();
      this.relatedRequest = null;
    }
    if (this.showsRequest) {
      this.showsRequest.abort();
      this.showsRequest = null;
    }
  }

  configureTabs(data) {
    const tabs = [{ active: true, label: 'Overview', tab: 'overview' }];
    if (!data.AnyOpted) {
      if (data.Galleries && data.Galleries.length > 0) tabs.push({ label: 'Representation', tab: 'representation' });
      tabs.push({ label: 'Related Artists', tab: 'related' });
    }
    if (!data.IsGhost) {
      tabs.push({ label: 'Artwork', tab: 'artwork' });
      if (data.Bio && data.Bio.length) tabs.push({ label: 'About', tab: 'about' });
      tabs.push({ label: 'Shows', tab: 'shows' });
      if (data.Galleries && data.Galleries.length > 0) tabs.push({ label: 'Representation', tab: 'representation' });
      tabs.push({ label: 'Followers', tab: 'followers' });  
    }
    if (this.state.CanProspect) {
      tabs.push({ label: 'Prospects', tab: 'prospects' });
    }

    this.props.onConfigureTabs(tabs, 'overview');
  }

  getArtwork(artistId) {
    const component = this;
    const state = component.state.artwork;
    if (state.loading) {
      return;
    }
    state.loading = true;
    component.setState({
      artwork: state,
    });
    component.artworkRequest = Artcloud.api.get(
      Artcloud.url.vendor.marketplace.artists.art.get(artistId),
      {
        dir: state.dir,
        limit: state.limit,
        offset: state.offset,
        order: state.order,
      },
      function (responseData) {
        component.artworkRequest = null;

        const art = responseData.Art || [];
        art.forEach(function (d) {
          Artcloud.mkt.art._isfavorite(d);
        });
        let data = state.data || [];
        state.data = data.concat(art);

        state.offset += art.length;
        state.total = responseData.Total;

        state.loading = false;
        component.setState({
          artwork: state,
        });
      },
      function (jqXHR, textStatus) {
        component.artworkRequest = null;

        if (!state.data) {
          state.data = [];
        }
        state.loading = false;
        component.setState({
          artwork: state,
        });
        Artcloud.api.fail(jqXHR, textStatus);
      }
    );
  }

  getArtworkMarketplace() {
    const component = this;
    component.artworkMarketplaceRequest = Artcloud.api.get(
      Artcloud.url.vendor.marketplace.art.get(),
      {
        galleryType: 'featured',
        limit: 30,
        offset: 0
      },
      function (responseData) {
        component.artworkMarketplaceRequest = null;
        component.setState({
          artworkMarketplace: {
            data: responseData.Data,
          }
        });
      },
      function (jqXHR, textStatus) {
        component.artworkMarketplaceRequest = null;
        Artcloud.api.fail(jqXHR, textStatus);
      }
    );
  }

  getFollowers(artistId) {
    const component = this;
    component.followersRequest = Artcloud.api.get(
      Artcloud.url.vendor.marketplace.artists.followers.get(artistId),
      null,
      function (responseData) {
        component.followersRequest = null;
        component.setState({
          followers: {
            data: responseData.Profiles || [],
          },
        });
      },
      function (jqXHR, textStatus) {
        component.followersRequest = null;

        component.setState({
          followers: {
            data: [],
          },
        });
        Artcloud.api.fail(jqXHR, textStatus);
      }
    );
  }

  getRelated(artistId) {
    const component = this;
    component.relatedRequest = Artcloud.api.get(
      Artcloud.url.vendor.marketplace.artists.related.get(artistId),
      null,
      function (responseData) {
        component.relatedRequest = null;
        component.setState({
          related: {
            data: responseData.Artists || [],
          },
        });
      },
      function (jqXHR, textStatus) {
        component.relatedRequest = null;
        component.setState({
          related: {
            data: [],
          },
        });
        Artcloud.api.fail(jqXHR, textStatus);
      }
    );
  }

  getShows(artistId) {
    const component = this;
    const state = component.state.shows;
    if (state.loading) {
      return;
    }
    state.loading = true;
    component.setState({
      shows: state,
    });
    component.showsRequest = Artcloud.api.get(
      Artcloud.url.vendor.marketplace.artists.shows.get(artistId),
      {
        dir: state.dir,
        limit: state.limit,
        offset: state.offset,
        order: state.order,
      },
      function (responseData) {
        component.showsRequest = null;

        const shows = responseData.Shows || [];
        let data = state.data || [];
        state.data = data.concat(shows);

        state.offset += shows.length;
        state.total = responseData.Total;

        state.loading = false;
        component.setState({
          shows: state,
        });
      },
      function (jqXHR, textStatus) {
        component.showsRequest = null;

        if (!state.data) {
          state.data = [];
        }
        state.loading = false;
        component.setState({
          shows: state,
        });
        Artcloud.api.fail(jqXHR, textStatus);
      }
    );
  }

  handleArtworkLikeChange(d) {
    const state = this.state.artwork;
    let artwork;
    for (let i = 0; i < state.data.length; i++) {
      let temp = state.data[i];
      if (!temp || temp.ArtId != d.ArtId) {
        continue;
      }
      artwork = temp;
      break;
    }
    if (!artwork) {
      return;
    }
    const component = this;
    Artcloud.mkt.art.updateFavorite(
      artwork.ArtId,
      !artwork.IsFavorite,
      artwork.Title,
      function () {
        if (!_ArtistInst) {
          return;
        }
        artwork.IsFavorite = !artwork.IsFavorite;
        component.setState({
          artwork: state,
          listArtworkAddModal: {
            data: artwork,
            visible: true,
          },
        });
      }
    );
  }

  handleArtworkWaypointEnter() {
    if (
      !this.state.artwork.data ||
      (this.state.artwork.data &&
        this.state.artwork.offset >= this.state.artwork.total)
    ) {
      return;
    }
    this.getArtwork(this.props.data.ArtistId);
  }

  handleFollowChange() {
    const component = this;
    const artist = this.props.data;
    Artcloud.mkt.artists.updateFollowing(
      artist.ArtistId,
      !artist.IsFollowing,
      artist.Name,
      function (success) {
        if (success != true || !_ArtistInst) {
          return;
        }
        artist.IsFollowing = !artist.IsFollowing;
        component.props.onUpdateData(artist);
      }
    );
  }

  handleGalleryFollowChange(d) {
    const state = this.props.data;
    let gallery;
    for (let i = 0; i < state.Galleries.length; i++) {
      let temp = state.Galleries[i];
      if (!temp || temp.GalleryId != d.GalleryId) {
        continue;
      }
      gallery = temp;
      break;
    }
    if (!gallery) {
      return;
    }
    const component = this;
    Artcloud.mkt.galleries.updateFollowing(
      gallery.GalleryId,
      !gallery.IsFollowing,
      gallery.Company,
      function (success) {
        if (success != true || !_ArtistInst) {
          return;
        }
        gallery.IsFollowing = !gallery.IsFollowing;
        component.props.onUpdateData(state);
      }
    );
  }

  handleListArtworkAddModalClose() {
    this.setState({
      listArtworkAddModal: undefined,
    });
  }

  handleParseRelatedArtwork(responseData) {
    const data = [];
    if (!responseData.Art) {
      return data;
    }
    for (let i = 0; i < responseData.Art.length; i++) {
      const d = responseData.Art[i];
      if (d.ArtistId == this.props.data.ArtistId) {
        continue;
      }
      Artcloud.mkt.art._isfavorite(d);
      data.push(d);
    }
    return data;
  }

  handleRelatedArtworkLikeChange(d) {
    if (!_ArtistInst) {
      return;
    }
    this.setState({
      listArtworkAddModal: {
        data: d,
        visible: true,
      },
    });
  }

  handleShowsWaypointEnter() {
    if (
      !this.state.shows.data ||
      (this.state.shows.data &&
        this.state.shows.offset >= this.state.shows.total)
    ) {
      return;
    }
    this.getShows(this.props.data.ArtistId);
  }

  render() {
    const data = this.props.data || {};
    let imageStyle;
    if (data.Image) {
      imageStyle = { backgroundImage: `url('${data.Image.Url}')` };
    }
    let artworkStyle;
    let className = 'tabs__content tabs__content__active spacer--bottom';
    if (this.props.tab == 'artwork') {
      className += ' section--masonry';
    } else {
      artworkStyle = { display: 'none' };
    }
    return (
      <React.Fragment>
        <Spaced className="cover__container cover--artist section">
          {data.Image && <div className="cover__img" style={imageStyle} />}
          <div className="cover__content">
            <div className="cover__name">
              <h1>{data.Name}</h1>
              <FollowButton data={data} onChange={this.handleFollowChange} />
            </div>
          </div>
        </Spaced>

        {this.props.data && this.props.data.ArtistId && !this.props.data.AnyOpted &&
        <React.Fragment>
          <Tab tabs={this.props.tabs} onClick={this.props.onTabClick} />
          <Section>
            <Spaced className={className}>
            {this.props.tab == 'overview' &&
              <React.Fragment>
                <Section className="section--artists">
                    <ArtistsSlider
                      sliderClassName="slider--grid-2"
                      data={this.state.related.data.filter(x => x.Image != null)}
                      titleContent={(<Title>
                          <h2>Related Artists</h2>
                          <Arrows display="See All" link="/artists" />
                        </Title>)}/>
                </Section>
                <Section className="section--browse">
                  <ArtworkSlider
                    //data={this.state.artworkMarketplace.data}
                    url={Artcloud.url.vendor.marketplace.art.get()}
                    q={{
                      galleryType: 'featured',
                      limit: 30,
                      offset: 0,
                    }}
                    slideProps={{
                      height: 250,
                      onLikeChange: this.handleArtworkLikeChange
                    }}
                    titleContent={<Title>
                        <h2>Marketplace Artworks</h2>
                        <Arrows display="See All" link="/browse" />
                      </Title>}/>
                </Section>
                <Section className="section--artists">
                  <ArtistsSlider
                    q={{ limit: 30, offset: 0, order: 'density' }}
                    sliderClassName="slider--grid-2"
                    url={Artcloud.url.vendor.marketplace.artists.get()}
                    titleContent={<Title>
                        <h2>Artists</h2>
                        <Arrows display="See All" link="/artists" />
                      </Title>}/>
                </Section>
              </React.Fragment>}
              {this.props.tab == 'representation' && this.props.data && (
                <React.Fragment>
                  {(!this.props.data.Galleries ||
                    this.props.data.Galleries.length == 0) && (
                    <NoResults display="No Representation" />
                  )}
                  {this.props.data.Galleries &&
                    this.props.data.Galleries.length > 0 && (
                      <Spaced>
                        {this.props.data.Galleries.map((d) => (
                          <GalleryCell
                            key={d.GalleryId}
                            d={d}
                            col={3}
                            onFollowChange={this.handleGalleryFollowChange}
                          />
                        ))}
                      </Spaced>
                    )}
                </React.Fragment>
              )}
              {this.props.tab == 'related' && this.state.related.data && this.state.related.data.length > 0 &&
                <div className="artist__grid--cont">
                    {this.state.related.data.map((d) => <ArtistSlim key={d.Slug} d={d} />)}
                </div>
              }
              {this.props.tab == 'prospects' &&
                <Prospects url={Artcloud.url.vendor.marketplace.artists.prospects.get(this.props.data.ArtistId)} />}
            </Spaced>
          </Section>
        </React.Fragment>}

        {this.props.data && this.props.data.ArtistId && !this.props.data.IsGhost &&
        <React.Fragment>
          <Tab tabs={this.props.tabs} onClick={this.props.onTabClick} />
          <Section>
            <Spaced className={className}>
              {!this.props.data && <LoadingIndicator />}
              {this.props.tab == 'overview' && (
                <React.Fragment>
                  <Spaced className="spacer--bottom">
                    {this.state.artwork.data && this.state.artwork.data.length > 0 && (
                      <ArtworkSlider
                        className="container--slider"
                        hideOnEmpty={true}
                        id={this.props.data.ArtistId}
                        data={this.state.artwork.data}
                        slideProps={{
                          style: { minWidth: '115px' },
                          onLikeChange: this.handleRelatedArtworkLikeChange
                        }}
                        titleContent={(
                          <TitleSpaced>
                            <h2>Works</h2>
                          </TitleSpaced>
                        )}
                        onParseResults={this.handleParseRelatedArtwork}
                      />
                    )}
                    {this.state.artwork.loading && <LoadingIndicator />}
                  </Spaced>

                  {this.props.data.Bio && this.props.data.Bio.length && (
                    <Spaced className="spacer--bottom">
                      <TitleSpaced>
                        <h2>Bio</h2>
                      </TitleSpaced>
                      <div className="grid grid--4">
                        {this.props.data.Profile && (
                          <LinkedImage
                            type="fit"
                            cols={4}
                            height={250}
                            alt={
                              this.props.data.Artist
                                ? this.props.data.Artist.Name
                                : data.Name
                            }
                            title={
                              this.props.data.Artist
                                ? this.props.data.Artist.Name
                                : data.Name
                            }
                            image={this.props.data.Profile}
                          />
                        )}
                      </div>
                      <div className="grid grid--8 spacer--mtop">
                        <div className="section--narrow">
                          <p className="text--details">
                            <span style={{ display: 'block' }} dangerouslySetInnerHTML={{__html: this.props.data.Bio}}></span>
                          </p>
                        </div>
                      </div>
                    </Spaced>
                  )}

                  {this.state.shows.data && (
                    <Spaced className="spacer--bottom">
                      <ShowsSlider
                        data={this.state.shows.data}
                        id="shows"
                        noResultsText="No Shows"
                        slideProps={{ height: 250, cols: 2 }}
                        titleContent={(
                          <TitleSpaced>
                            <h2>Shows</h2>
                          </TitleSpaced>
                        )} />
                    </Spaced>
                  )}
                  
                  {this.state.shows.loading && <LoadingIndicator />}

                  {this.props.data && this.props.data.ArtistId && (
                    <React.Fragment>
                      <TitleSpaced>
                        <h2>Works from related artists</h2>
                      </TitleSpaced>
                      <ArtworkSlider
                        className="container--slider"
                        hideOnEmpty={true}
                        id={this.props.data.ArtistId}
                        slideProps={{
                          style: { minWidth: '115px' },
                          onLikeChange: this.handleRelatedArtworkLikeChange
                        }}
                        url={Artcloud.url.vendor.marketplace.artists.art.related(
                          this.props.data.ArtistId
                        )}
                        onParseResults={this.handleParseRelatedArtwork}
                      />
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
              
              {this.props.tab == 'artwork' && (
                <div style={artworkStyle}>
                  <ArtworkGridContainer
                    sizeClassName="art__container grid--3"
                    onWaypointEnter={this.handleArtworkWaypointEnter}
                  >
                    {this.state.artwork.data &&
                      this.state.artwork.data.length > 0 &&
                      this.state.artwork.data.map((d) => (
                        <ArtworkCell
                          key={d.ArtId}
                          className="grid--3"
                          d={d}
                          onLikeChange={this.handleArtworkLikeChange}
                          cols={4}
                        />
                      ))}
                  </ArtworkGridContainer>
                  {this.state.artwork.loading && <LoadingIndicator />}
                  {this.props.data && this.props.data.ArtistId && (
                    <ArtworkSlider
                      className="container--slider"
                      hideOnEmpty={true}
                      id={this.props.data.ArtistId}
                      slideProps={{
                        style: { minWidth: '115px' },
                        onLikeChange: this.handleRelatedArtworkLikeChange,
                      }}
                      title="Works from related artists"
                      titleSmall={true}
                      url={Artcloud.url.vendor.marketplace.artists.art.related(
                        this.props.data.ArtistId
                      )}
                      onParseResults={this.handleParseRelatedArtwork}
                    />
                  )}
                </div>
              )}

              {this.props.tab == 'about' && this.props.data && (
                <Spaced className="container--spaced__row">
                  <div className="grid grid--4">
                    {this.props.data.Profile && (
                      <LinkedImage
                        type="fit"
                        cols={4}
                        height={250}
                        alt={
                          this.props.data.Artist
                            ? this.props.data.Artist.Name
                            : data.Name
                        }
                        title={
                          this.props.data.Artist
                            ? this.props.data.Artist.Name
                            : data.Name
                        }
                        image={this.props.data.Profile}
                      />
                    )}
                  </div>
                  <div className="grid grid--8 spacer--mtop">
                    <div className="section--narrow">
                      <p className="text--details">
                        <span style={{ display: 'block' }} dangerouslySetInnerHTML={{__html: this.props.data.Bio}}></span>
                      </p>
                    </div>
                  </div>
                </Spaced>
              )}
              {this.props.tab == 'shows' && (
                <React.Fragment>
                  {this.state.shows.data && (
                    <React.Fragment>
                      {this.state.shows.data.length == 0 && (
                        <NoResults display="No Shows" />
                      )}
                      {this.state.shows.data.length > 0 && (
                        <Spaced className="show__grid--cont container--waypoint">
                          {this.state.shows.data.map((d) => (
                            <_ShowCell key={d.ShowId} d={d} />
                          ))}
                          <div className="loading--waypoint">
                            <Landmark useWindow={true} onEnter={this.handleShowsWaypointEnter} />
                          </div>
                        </Spaced>
                      )}
                    </React.Fragment>
                  )}
                  {this.state.shows.loading && <LoadingIndicator />}
                </React.Fragment>
              )}
              {this.props.tab == 'representation' && this.props.data && (
                <React.Fragment>
                  {(!this.props.data.Galleries ||
                    this.props.data.Galleries.length == 0) && (
                    <NoResults display="No Representation" />
                  )}
                  {this.props.data.Galleries &&
                    this.props.data.Galleries.length > 0 && (
                      <Spaced>
                        {this.props.data.Galleries.map((d) => (
                          <GalleryCell
                            key={d.GalleryId}
                            d={d}
                            col={3}
                            onFollowChange={this.handleGalleryFollowChange}
                          />
                        ))}
                      </Spaced>
                    )}
                </React.Fragment>
              )}
              {this.props.tab == 'followers' && (
                <React.Fragment>
                  {this.state.followers.loading && <LoadingIndicator />}
                  {this.state.followers.data && (
                    <React.Fragment>
                      {this.state.followers.data.length == 0 && (
                        <NoResults display="No Followers" />
                      )}
                      {this.state.followers.data.length > 0 && (
                        <div className="container">
                          {this.state.followers.data.map((d) => (
                            <ProfileCell key={d.ProfileId} d={d} />
                          ))}
                        </div>
                      )}
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
              {this.props.tab == 'prospects' &&
                <Prospects url={Artcloud.url.vendor.marketplace.artists.prospects.get(this.props.data.ArtistId)} />}
            </Spaced>
          </Section>
        </React.Fragment>}
        {this.state.listArtworkAddModal &&
          this.state.listArtworkAddModal.visible && (
            <ListArtworkAdd
              data={this.state.listArtworkAddModal.data}
              onClose={this.handleListArtworkAddModalClose}
            />
          )}
      </React.Fragment>
    );
  }
}

function _ShowCell(props) {
  return (
    <div className="grid grid--6 spacer--bottom">
      <ShowCell cols={2} slider={false} {...props} />
    </div>
  );
}

const Artist = forResource(
  _Artist,
  Artcloud.url.vendor.marketplace.artists.getid
);
export default Artist;
